module.exports = __webpack_public_path__ + "img/48_27.68cfbeed.png";